import React from 'react';
import { CancellationDashboard } from '../modules/dashboard';

export const CancellationDashboardPage = () => {
    return (
        <CancellationDashboard />
    );
};
